export default __webpack_public_path__ + "static/media/pic2.a687683f.jpg";